import { SVGProps } from 'react';

const HandGrab = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M18 11.5V9a2 2 0 1 0-4 0v1.4m0-.4V8a2 2 0 1 0-4 0v2m0-.1V9a2 2 0 1 0-4 0v5a2 2 0 0 0-4 0 8 8 0 0 0 8 8h4a8 8 0 0 0 8-8v-3a2 2 0 1 0-4 0"
    />
  </svg>
);
export default HandGrab;
